










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponetsOrdersComponetsOrderInfo extends Vue {
  @Prop({ type: String, default: '' })
  location: string;

  @Prop({ type: String, default: '' })
  members: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderInfo.vue